export default __webpack_public_path__ + "static/media/icon-software-development-round.eacd9246.svg";